import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["isMobile", "withControls", "nextControlRef", "prevControlRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Swiper } from 'swiper/core';
import { EffectCreative, Navigation } from 'swiper/modules';
var defaultCreativeEffect = {
  prev: {
    shadow: true,
    translate: ['-20%', 0, -1]
  },
  next: {
    translate: ['100%', 0, 0]
  }
};
var composeSwiperModules = function composeSwiperModules(mode, _ref) {
  var withControls = _ref.withControls,
    effect = _ref.effect,
    userModules = _ref.modules;
  var modules = [].concat(_toConsumableArray(withControls ? [Navigation] : []), _toConsumableArray(userModules || []));
  if (mode === 'default') {
    return [].concat(_toConsumableArray(modules), _toConsumableArray(effect !== 'creative' ? [EffectCreative] : []));
  }
  return modules;
};
export var createSwiperInstance = function createSwiperInstance(node, mode, _ref2) {
  var isMobile = _ref2.isMobile,
    withControls = _ref2.withControls,
    nextControlRef = _ref2.nextControlRef,
    prevControlRef = _ref2.prevControlRef,
    options = _objectWithoutProperties(_ref2, _excluded);
  var navigation = withControls ? {
    nextEl: nextControlRef === null || nextControlRef === void 0 ? void 0 : nextControlRef.current,
    prevEl: prevControlRef === null || prevControlRef === void 0 ? void 0 : prevControlRef.current
  } : options.navigation;
  return new Swiper(node, _objectSpread(_objectSpread(_objectSpread({}, options), {}, {
    touchEventsTarget: 'wrapper',
    speed: options.speed || 1500
  }, mode === 'default' ? {
    effect: (options === null || options === void 0 ? void 0 : options.effect) || 'creative',
    creativeEffect: (options === null || options === void 0 ? void 0 : options.creativeEffect) || defaultCreativeEffect
  } : {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: isMobile ? 8 : 40
  }), {}, {
    modules: composeSwiperModules(mode, _objectSpread({
      withControls: withControls
    }, options)),
    navigation: navigation
  }));
};